import { getCode, getData } from "country-list";

export const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };
  export let currencyType = {
  "PKR": {
   // replace with your actual PKR image
    code: "Rs.",
    name: "Pakistani Rupee"
  },
  "USD": {
      // replace with your actual USD image
    code: "$",
    name: "US Dollar"
  },
  "AED": {
       // replace with your actual AED image
    code: "AED",
    name: "UAE Dirham"
  }
};


export const getCountryCode = (countryName) => {
  
  console.log(countryName,'countryNamecountryName');
  

  const countries = Object.fromEntries(
  getData().map(c => [
    c.name.toLowerCase().replace(/\s*\([^)]*\)/g, '').trim(),
    c.code
  ])
);

  console.log(countries,'getCountryCode()');
  console.log(process.env.REACT_APP_COUNTRY,'getCountryCode');
  
  
console.log(countries[process.env.REACT_APP_COUNTRY?.toLowerCase()] || null);

  return countries[process.env.REACT_APP_COUNTRY?.toLowerCase()] || null;
};
